module.exports = __webpack_public_path__ + "assets/disable.0fba55f8.svg";